import { useState, useMemo, useCallback, useEffect } from "react";
import { useGetDealerRolesBelowFirmsQuery } from "../../store/dealerRoles/firmApi";

export function useBelowFirmsData({ id, token }) {
  const [paginationNumber, setPaginationNumber] = useState(1);
  const [filteredData, setFilteredData] = useState("");
  const [isSearch, setIsSearch] = useState(false);

  const {
    data: belowFirmsData,
    isLoading: belowFirmsIsLoading,
    isFetching: belowFirmsIsFetching,
    error: belowFirmsError,
  } = useGetDealerRolesBelowFirmsQuery(
    { id, token },
    {
      refetchOnMountOrArgChange: true,
      skip: !token || !id,
    }
  );

  const belowFirms = useMemo(
    () => belowFirmsData?.data?.belowFirms || [],
    [belowFirmsData]
  );

  const handleSearch = useCallback((data, isSearch) => {
    setPaginationNumber(1);
    setFilteredData(data);
    setIsSearch(isSearch);
  }, []);

  useEffect(() => {
    setIsSearch(false);
  }, []);

  return {
    belowFirms,
    belowFirmsIsLoading,
    belowFirmsIsFetching,
    belowFirmsError,
    paginationNumber,
    setPaginationNumber,
    filteredData,
    isSearch,
    setIsSearch,
    handleSearch,
  };
}
